import React, { useState, useEffect } from "react";
import { Card, Button, Modal, Form, Row, Col, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import DataTable from "../../components/DataTable/DataTable";
import { CustomDropdownToggle, Icon } from "../../components";
import Swal from "sweetalert2";
import instance, { apiBaseUrl, imageUrl, uploadInstance } from "../api";
import { MdDelete, MdViewCozy } from "react-icons/md";
import { createPortal } from "react-dom";
import { Grid } from "@mui/material";

const CustomTickets = () => {
  const { ticket_id } = useParams();

  // NEW CODE
  const [searchText, setSearchText] = useState("");
  // NEW CODE ENDS

  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [ticketsData, setTicketsData] = useState([]);
  const [, setTickets] = useState([]);
  const [, setAttachment] = useState(null);
  const [attachmentUrl, setAttachmentUrl] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("");
  const [status, setStatus] = useState("");
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [editingTicket, setEditingTicket] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [fieldErrors, setFieldErrors] = useState({
    fullName: false,
    email: false,
    phone: false,
    subject: false,
    description: false,
    priority: false,
    status: false,
  });

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/tickets-manage/tickets-list");
    resetForm();
  };

  const handleShowViewModal = async (ticket_id) => {
    await fetchTicketDetails(ticket_id);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setFullName("");
    setEmail("");
    setPhone("");
    setSubject("");
    setDescription("");
    setPriority("");
    setAttachment(null);
    setAttachmentUrl(null);
    setStatus("");
    setEditingTicket(null);
  };

  const resetForm = () => {
    setFullName("");
    setEmail("");
    setPhone("");
    setSubject("");
    setDescription("");
    setPriority("");
    setStatus("");
    setEditingTicket(null);
    setFieldErrors({
      fullName: false,
      email: false,
      phone: false,
      subject: false,
      description: false,
      priority: false,
      status: false,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!fullName) errors.fullName = true;
    if (!email || !/\S+@\S+\.\S+/.test(email)) errors.email = true;
    if (!phone) errors.phone = true;
    if (!subject) errors.subject = true;
    if (!description) errors.description = true;
    if (!priority) errors.priority = true;
    if (!status) errors.status = true;

    setFieldErrors(errors);

    return !Object.values(errors).some((error) => error);
  };

  const fetchTicketDetails = async (ticket_id) => {
    try {
      const response = await instance.get(`api/Ticket/${ticket_id}`);
      const ticket = response.data;
      setTickets(response.data.rows);
      setFullName(ticket.full_name || "");
      setEmail(ticket.email || "");
      setPhone(ticket.phone || "");
      setSubject(ticket.subject || "");
      setDescription(ticket.description || "");
      setPriority(ticket.priority || "");
      setStatus(ticket.status || "");
      setAttachmentUrl(ticket.attachment || "");

      setComments(ticket.Comments || []);
      setEditingTicket(ticket);
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };
  const handleFileChange = async (event) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setAttachment(file);
      console.log(file);
      const formData = new FormData();
      formData.append("files", file);
      console.log(formData);
      try {
        const uploadResponse = await uploadInstance.post(
          "api/Common/Upload",
          formData
        );
        if (uploadResponse.data.message === "uploaded file.") {
          const uploadedAttachmentUrl = uploadResponse.data.file_paths[0];
          setAttachmentUrl(uploadedAttachmentUrl);
        } else {
          console.error("Error uploading file:", "error");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const postTicketData = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const payload = {
        full_name: fullName,
        email: email,
        phone: phone,
        subject: subject,
        description: description,
        priority: priority,
        status: status,
        attachment: attachmentUrl,
      };

      let ticketResponse;
      if (editingTicket) {
        ticketResponse = await instance.put(
          `api/Ticket/update/${editingTicket.ticket_id}`,
          payload
        );
      } else {
        ticketResponse = await instance.post("api/Ticket/create", payload);
      }

      console.log("Ticket response:", ticketResponse.data);

      handleCloseModal();
      Swal.fire("Success", "Ticket updated successfully!", "success");

      const updatedResponse = await instance.get("api/Ticket");
      setTicketsData(updatedResponse.data.rows);
    } catch (error) {
      Swal.fire("Error", "Failed to update Ticket!", "error");
    }
  };

  const postComment = async () => {
    if (!newComment) return;

    try {
      const payload = {
        ticket_id: editingTicket.ticket_id,
        comment: newComment,
        writer: "Admin",
      };

      await instance.post("api/Ticket/comment/create", payload);
      fetchTicketDetails(editingTicket.ticket_id);

      setNewComment("");
    } catch (error) {
      Swal.fire("Error", "Failed to post comment!", "error");
    }
  };

  const fetchData = async (page, pageSize) => {
    try {
      const queryParams =
        `pageSize=${pageSize}&page=${page}` +
        (searchText ? `&search=${searchText}` : "");

      const response = await instance.get(
        // `api/Ticket?pageSize=${pageSize}&page=${page}`
        `api/Ticket?${queryParams}`
      );
      setTicketsData(response.data.rows);
      setTotalCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData(page, rowsPerPage);
    if (ticket_id) {
      fetchTicketDetails(ticket_id);
    }
  }, [ticket_id, page, rowsPerPage, searchText]);

  // NEW CODE
  const handleSearchTextChange = (text) => {
    setSearchText(text);
  };
  // NEW CODE ENDS

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
  };

  const handleDeleteTicket = async (ticket_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this ticket?"
    );
    if (confirmed) {
      try {
        await instance.delete(`api/Ticket/delete/${ticket_id}`);
        console.log(`Ticket with ID ${ticket_id} deleted successfully.`);
        Swal.fire("Success", "Ticket deleted successfully!", "success");

        const updatedResponse = await instance.get("api/Ticket");
        setTicketsData(updatedResponse.data.rows);
      } catch (error) {
        console.error(`Error deleting ticket with ID ${ticket_id}:`, error);
        Swal.fire("Error", "Failed to delete ticket!", "error");
      }
    }
  };

  const handleStatusChange = async (ticket_id, newStatus) => {
    try {
      const payload = { status: newStatus };
      await instance.put(`api/Ticket/update/${ticket_id}`, payload);

      Swal.fire("Success", "Ticket status updated successfully!", "success");
      const updatedResponse = await instance.get("api/Ticket");
      setTicketsData(updatedResponse.data.rows);
    } catch (error) {
      console.error(
        `Error updating ticket status with ID ${ticket_id}:`,
        error
      );
      Swal.fire("Error", "Failed to update ticket status!", "error");
    }
  };

  const ticketColumns = [
    {
      name: "Ticket",
      selector: "ticket_id",
      sortable: true,
      cell: (row) => (
        <span
          onClick={() => handleShowViewModal(row.ticket_id)}
          style={{ color: "blue", cursor: "pointer" }}
        >
          View Ticket {row.ticket_id}
        </span>
      ),
    },
    { name: "Full Name", selector: "full_name", sortable: true },
    { name: "Phone", selector: "phone", sortable: true },
    { name: "Subject", selector: "subject", sortable: true },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle
            className={`status-dropdown ${row.status.toLowerCase()}`}
          >
            {row.status}
          </Dropdown.Toggle>
          {createPortal(
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => handleStatusChange(row.ticket_id, "open")}
                style={{ backgroundColor: "grey", color: "white" }}
              >
                Open
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleStatusChange(row.ticket_id, "Inprogress")}
                style={{ backgroundColor: "orange", color: "white" }}
              >
                In Progress
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleStatusChange(row.ticket_id, "closed")}
                style={{ backgroundColor: "green", color: "white" }}
              >
                Closed
              </Dropdown.Item>
            </Dropdown.Menu>,
            document.body
          )}
        </Dropdown>
      ),
    },
    {
      name: "Created At",
      selector: "createdAt",
      sortable: true,
      format: (row) =>
        new Date(row.createdAt).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
    },
    {
      name: "Action",
      selector: "action",
      sortable: true,
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => handleShowViewModal(row.ticket_id)}
                >
                  <MdViewCozy /> View
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handleDeleteTicket(row.ticket_id)}
                >
                  <MdDelete /> Delete
                </Dropdown.Item>
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <Layout title="Tickets List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Tickets List</Block.Title>
            {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">Tickets Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Tickets</li>
                            </ol>
                        </nav> */}
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add Ticket</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            data={ticketsData}
            columns={ticketColumns}
            searchList={["full_name"]}
            searchTerm="Full Name"
            totalCount={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            // NEW ONE
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
          />
        </Card>
      </Block>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingTicket ? "Edit Ticket" : "Add Ticket"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter full name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  isInvalid={fieldErrors.fullName}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a full name.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isInvalid={fieldErrors.email}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid email.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  isInvalid={fieldErrors.phone}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a phone number.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="subject">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  isInvalid={fieldErrors.subject}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a subject.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  isInvalid={fieldErrors.description}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a description.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="priority">
                <Form.Label>Priority</Form.Label>
                <Form.Control
                  as="select"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                  isInvalid={fieldErrors.priority}
                >
                  <option value="">Select priority</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please select a priority.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="status">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  isInvalid={fieldErrors.status}
                >
                  <option value="">Select status</option>
                  <option value="open">Open</option>
                  <option value="Inprogress">In Progress</option>
                  <option value="closed">Closed</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please select a status.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="attachment">
                <Form.Label>Attachment</Form.Label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  accept="image/*,application/pdf"
                  className="form-control"
                />
                {attachmentUrl && (
                  <Grid item xs={12} className="mt-2">
                    <img
                      src={`${apiBaseUrl}${attachmentUrl}`}
                      alt="Attachment"
                      style={{
                        maxWidth: "50px",
                        maxHeight: "70px",
                        marginTop: "10px",
                      }}
                    />
                  </Grid>
                )}
              </Form.Group>
            </Row>
            <Button variant="primary" onClick={postTicketData}>
              {editingTicket ? "Update Ticket" : "Add Ticket"}
            </Button>{" "}
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showViewModal} onHide={handleCloseViewModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Ticket Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingTicket && (
            <div className="ticket-details-container">
              <div className="ticket-main">
                <div className="ticket-info">
                  <h5>#{editingTicket.ticket_id}</h5>
                  <p>
                    <strong>Reported By:</strong> {editingTicket.full_name}
                  </p>
                  <p>
                    <strong>Email:</strong> {editingTicket.email}
                  </p>
                  <p>
                    <strong>Phone:</strong> {editingTicket.phone}
                  </p>
                  <p>
                    <strong>Created On:</strong>{" "}
                    {new Date(editingTicket.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </p>
                  <p>
                    <strong>Subject:</strong> {editingTicket.subject}
                  </p>
                  <p>
                    <strong>Description:</strong> {editingTicket.description}
                  </p>
                  <p>
                    <strong>Priority:</strong> {editingTicket.priority}
                  </p>
                  <p>
                    <strong>Status:</strong> {editingTicket.status}
                  </p>
                  {editingTicket.attachment && (
                    <div>
                      <p>
                        <strong>
                          Attachment:{" "}
                          {editingTicket.attachment.endsWith(".pdf") ? (
                            <div>
                              <a
                                href={`${imageUrl}${editingTicket.attachment}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                View PDF
                              </a>
                            </div>
                          ) : (
                            <div>
                              <a
                                href={`${imageUrl}${editingTicket.attachment}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                View Image
                              </a>
                            </div>
                          )}
                        </strong>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="ticket-comments">
                <h6>Comments</h6>
                <ul>
                  {comments.map((comment, index) => (
                    <li key={index}>
                      <p>{comment.comment}</p>
                      <small>
                        {comment.writer} -{" "}
                        {new Date(comment.createdAt).toLocaleString()}
                      </small>
                    </li>
                  ))}
                </ul>
                <Form.Group controlId="newComment">
                  <Form.Label>Add Comment</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={postComment}
                  className="mt-3"
                >
                  Send
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export const handleDeleteTicket = async (ticket_id, setTicketsData) => {
  const confirmed = window.confirm(
    "Are you sure you want to delete this ticket?"
  );
  if (confirmed) {
    try {
      await instance.delete(`api/Ticket/delete/${ticket_id}`);
      console.log(`Ticket with ID ${ticket_id} deleted successfully.`);
      Swal.fire("Success", "Ticket deleted successfully!", "success");

      const updatedResponse = await instance.get("api/Ticket");
      setTicketsData(updatedResponse.data.rows);
    } catch (error) {
      console.error(`Error deleting ticket with ID ${ticket_id}:`, error);
      Swal.fire("Error", "Failed to delete ticket!", "error");
    }
  }
};

export default CustomTickets;
